import { useAccessToken } from '@/features/auth/state/auth'
import api from '@/lib/api'
import { useQuery } from '@tanstack/react-query'
export function useFetchContractstById(id_client: string, options?: { enabled?: boolean }) {
  const token = useAccessToken()
  return useQuery({
    queryKey: ['contracts', id_client],
    queryFn: async () => {
      const response = await api.get(`agreement/listContract/${id_client}`, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (response.data) {
        return response.data.data
      } else {
        throw new Error('Estrutura de resposta inesperada')
      }
    },
    enabled: options?.enabled
  })
}
